<template>
  <div class="reply-box">
    <textarea v-model="message" placeholder="Type something..." maxLength="1000" @keydown.enter="postMessage"></textarea>
  </div>
</template>

<script>
export default {
  name: "ReplyBox",

  data() {
    return {
      message: ""
    };
  },

  methods: {
    postMessage(ev) {
      if (ev.shiftKey) return;

      ev.preventDefault();
      this.$emit("submit", this.message);
      this.message = "";
    }
  }
};
</script>
